import * as services from "../service/services";
import axios from "axios";
import * as types from "./mutation-types";

function setOrder(familles){
  let divers = familles.find((f)=> f.nom.toLowerCase() == 'divers');
    if (divers) {
      let index = familles.indexOf(divers);
      familles.splice(index, 1);
      familles.push(divers);
    }
    return familles;
}
export default {
  setCotation({ commit }, payload) {
    commit(types.SET_COTATION, payload);
  },
  reinitCotation({ commit }) {
    commit(types.REINIT_COTATION);
  },

  fillCotation({ commit }, payload) {
    commit(types.FILL_COTATION, payload);
  },

  getMenus ({ commit }) {
      return axios.get(services.GET_FILTER_MENU)
          .then(resp => {
              let familles = setOrder(resp.data.familles);
              commit(types.SET_MENU_FILTER, familles)
          })
          .catch()
  },

  setFilterSousFamille({ commit }, payload) {
    commit(types.SET_FILTER_S_F, payload);
  },

  reinitFilterSousFamille({ commit }) {
    commit(types.REINIT_S_F);
  },
};
